import { render, staticRenderFns } from "./CommentaryPlusInMetric.vue?vue&type=template&id=6c693f03&scoped=true"
import script from "./CommentaryPlusInMetric.vue?vue&type=script&lang=js"
export * from "./CommentaryPlusInMetric.vue?vue&type=script&lang=js"
import style0 from "./CommentaryPlusInMetric.vue?vue&type=style&index=0&id=6c693f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c693f03",
  null
  
)

export default component.exports